<template>

  <button type="button"
    class="min-w-s180 w-full grid items-center bg-black text-white text-t14 py-s10 px-s20 uppercase border border-black m_1000:hover:bg-light-gray m_1000:hover:text-black m_1000:hover:border-light-gray m_1000:transition-colors m_1000:duration-200 m_1200:text-t16 m_1200:px-s40 m_1200:min-w-s200"
    @click="addToCart">
    Dodaj u korpu
  </button>

</template>

<script>
import { EventBus } from '.././eventBus.js';
import accounting from "accounting";

export default {
	name: "AddToCart",

	props: [
		'price',
		'size',
		'product'
	],

	methods: {
		addToCart() {

			if (this.size.length > 0) {

				dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
				dataLayer.push({
					event: "add_to_cart",
					ecommerce: {
						currency: "RSD",
						value: this.formatPrice(this.price),
						items: [
							{
								item_name: this.product.title,
								item_id: this.product.movem_id,
								price: this.formatPrice(this.price),
								item_brand: this.product.brend.title,
								item_category: this.getCategoriesForFeed(),
								quantity: 1
							}
						]
					}
				});

				axios.post('/add-to-cart', {id: this.product.id, size: this.size})
					.then(response => {

						// Update vuex store, cart items
						this.$store.dispatch('Cart/changeCartItems', response.data.cartItems);
						// Update vuex store, cart count
						this.$store.dispatch('Cart/changeItemCount', response.data.cartItemsCount);
						// Update vuex store, cart total
						this.$store.dispatch('Cart/changeTotalPrice', response.data.totalPrice);
						// Update vuex store, cart subtotal
						this.$store.dispatch('Cart/changeSubtotalPrice', response.data.subtotalPrice);


						// Remove message about size if there is one on product page.
						this.$parent._data.message = null;

						const sideCart = document.getElementById('js_side_cart');
						const toAppearQuickView = document.getElementById('js_quick_view');

						sideCart.classList.add('grid');
						sideCart.classList.remove('hidden');
						sideCart.classList.remove('unactive');

						// document.body.classList.add('no_scroll');

						if (toAppearQuickView) {
							toAppearQuickView.style.display = 'none';
							this.$parent.$parent._data.showQuickView = false;
						}

						const sizeElements = document.querySelectorAll('.js_get_selected_size');
						sizeElements.forEach(element => {
							element.classList.remove('bg-black', 'text-white');
						});

					})
					.catch(error => {

						this.$toasted.global.toastError({ message: error.response.data.message });
						//console.log(error.message, error.response.data.message);
					})

				this.$parent._data.selectedSize = '';
			} else {

				// Fill message on quick view.
				EventBus.$emit('show-message');

				// Fill message on product page.
				this.$parent._data.message = 'Izaberite veličinu.';

			}
		},
		getCategoriesForFeed() {
			if (this.product.categories_for_feed) {
				this.product.categories_for_feed.forEach(function (value, i) {
					'item_category' + (i + 1) + ':' + value;
				})
			}
		},

		/**
		 * Format price.
		 *
		 * @param value
		 */
		formatPrice(value) {

			return accounting.formatMoney(value, '', 2, '', '.')
		},
	}

}
</script>